!function(window) {
function manageCookies(){

	$('.allow-cookie-button').on('click', function(){
		$.cookie('readCookie', 1, { expires : 3650, path : '/'});
		location.reload();
	});
	
	$('.disallow-cookie-button, .disallow-cookie-button-main').on('click', function(){
		$.cookie('readCookie', 2, { expires : 3650, path : '/'});
		location.reload();
	});
	
	$('.open-cookie').on('click', function(){
		$('.cookie-container').removeClass('hide-cookie');
	});
	
	$('.info-cookie-button').on('click', function(){
		$('.main-text').hide();
		$('.sub-text').show();
	});
	
	$(window).scroll(function() {
		if($(window).scrollTop() == $(document).height() - $(window).height()){
			$('.open-cookie').show();
		}else{
			$('.open-cookie').hide();
		}
	});
}

module.exports = {manageCookies : manageCookies};
window.manageCookies = manageCookies;
}(window);